@if (!hasPermission) {
  <div class="flex items-center justify-center gap-2 rounded-lg border border-red-200 bg-red-50 p-4 text-sm font-semibold text-red-700">
    <mat-icon class="!text-base text-red-400">lock</mat-icon>
    Permissions Restricted
  </div>
} @else {
  @if (loading) {
    <div class="flex justify-center py-4"><mat-spinner diameter="24" color="primary" /></div>
  }

  @if (error && !loading) {
    <div class="py-2 text-center text-sm text-red-500">{{ error }}</div>
  }

  @if (data && !loading) {
    <div class="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
      <!-- Opening Balance -->
      <div class="rounded-xl border bg-white p-3 shadow-sm">
        <div class="mb-1 flex items-center gap-2">
          <mat-icon class="text-gray-500 icon-size-4">account_balance</mat-icon>
          <span class="text-secondary text-xs">Opening Balance</span>
        </div>
        <div class="text-default text-right text-sm font-bold" [innerHTML]="data.opening_balance | amount"></div>
      </div>

      <!-- Charge -->
      <div class="rounded-xl border bg-white p-3 shadow-sm">
        <div class="mb-1 flex items-center gap-2">
          <mat-icon class="text-blue-600 icon-size-4">description</mat-icon>
          <span class="text-secondary text-xs">Charge</span>
        </div>
        <div class="text-default text-right text-sm font-bold" [innerHTML]="data.charge | amount"></div>
      </div>

      <!-- Collection — amount left, bar + % right on the same row -->
      <div class="rounded-xl border bg-white p-3 shadow-sm">
        <div class="mb-1 flex items-center gap-2">
          <mat-icon class="text-green-600 icon-size-4">payments</mat-icon>
          <span class="text-secondary text-xs">Collection</span>
        </div>
        <div class="flex items-center gap-2">
          <div class="shrink-0 text-sm font-bold text-green-700" [innerHTML]="data.collection | amount"></div>
          <div class="flex min-w-0 flex-1 items-center justify-end gap-1.5">
            <div class="h-1.5 w-32 overflow-hidden rounded-full bg-gray-100">
              <div
                class="h-full rounded-full transition-all"
                [class.bg-green-500]="collectionPct >= 90"
                [class.bg-yellow-400]="collectionPct >= 70 && collectionPct < 90"
                [class.bg-red-400]="collectionPct < 70"
                [style.width.%]="collectionPct"
              ></div>
            </div>
            <span class="shrink-0 text-[10px] font-semibold" [ngClass]="collectionColor">{{ data.collection_pct }}%</span>
          </div>
        </div>
      </div>

      <!-- Receivables -->
      <div class="rounded-xl border bg-white p-3 shadow-sm">
        <div class="mb-1 flex items-center gap-2">
          <mat-icon class="text-red-500 icon-size-4">account_balance_wallet</mat-icon>
          <span class="text-secondary text-xs">Receivables</span>
        </div>
        <div class="text-right text-sm font-bold text-red-600" [innerHTML]="data.receivables | amount"></div>
      </div>

      <!-- Payables Pending -->
      <div
        class="rounded-xl border bg-white p-3 shadow-sm"
        matTooltip="Total amount of vendor bills not yet approved for payment (new, sent for review, sent for approval, draft, resubmitted, or on hold)."
        matTooltipPosition="above"
      >
        <div class="mb-1 flex items-center gap-2">
          <mat-icon class="text-orange-500 icon-size-4">receipt_long</mat-icon>
          <span class="text-secondary text-xs">Payables Pending</span>
        </div>
        <div class="text-default text-right text-sm font-bold" [innerHTML]="data.payables_pending | amount"></div>
      </div>

      <!-- Budget Remaining -->
      <div
        class="rounded-xl border bg-white p-3 shadow-sm"
        matTooltip="Remaining expense budget for the current budget period (total budgeted expenses minus actual spend so far), across all communities."
        matTooltipPosition="above"
      >
        <div class="mb-1 flex items-center gap-2">
          <mat-icon class="text-teal-600 icon-size-4">savings</mat-icon>
          <span class="text-secondary text-xs">Budget Remaining</span>
        </div>
        <div class="text-right text-sm font-bold text-teal-700" [innerHTML]="data.budget_remaining | amount"></div>
      </div>

      <!-- Overspend Risk -->
      <div
        class="rounded-xl border p-3 shadow-sm"
        [ngClass]="data.overspend_risk_communities > 0 ? 'border-red-200 bg-red-50' : 'bg-white'"
        matTooltip="Number of communities whose actual expense spend has already exceeded their budgeted amount for the current period."
        matTooltipPosition="above"
      >
        <div class="mb-1 flex items-center gap-2">
          <mat-icon class="icon-size-4" [ngClass]="data.overspend_risk_communities > 0 ? 'text-red-600' : 'text-secondary'">warning</mat-icon>
          <span class="text-secondary text-xs">Overspend Risk</span>
        </div>
        <div class="text-sm font-bold" [ngClass]="data.overspend_risk_communities > 0 ? 'text-red-700' : 'text-default'">{{ data.overspend_risk_communities }} communities</div>
      </div>
    </div>
  } @else if (!loading && !error) {
    <div class="text-secondary flex flex-col items-center gap-2 py-6">
      <mat-icon>info</mat-icon>
      <span class="text-sm">No data available</span>
    </div>
  }
}
